import { CreatePolizaDTO, PolizaEditar, PolizaSeguro, UpdatePoliza } from "../models/polizaSeguro";
import { actualizarPoliza, crearPoliza } from "../service/servicePoliza";



export function usePoliza() {
    const save = async (data: PolizaSeguro, dataediting: UpdatePoliza | undefined) => {
        let dataRequest: any = {
            codigo: data.codigo,
            codigoHijo: data.codigohijo,
            nombreCompania: data.nombrecompania,
            tasa: data.tasa,
            diaPago: data.diapago,
            monedaRemesa: data.monedapagoCodigo,
            fechaInicioVigencia: data.fechainiciovigencia,
            fechaTerminoVigencia: data.fechaterminovigencia,
            descripcion: data.descripcion || null,
            tipoSeguro: data.tiposeguro || "",
            valorPrima: data.valorprima || 0,
        };
        if (dataediting) {
           return await actualizarPoliza(dataRequest);

        }

        return await crearPoliza(dataRequest);
        
        }

        return save
    }
